export default __webpack_public_path__ + "static/media/design.a664c5eb.jpg";